import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import apiSlice from 'src/store/api/apiSlice';
import { logOut } from 'src/store/reducers/auth';
import { cartReset } from 'src/store/reducers/cart';
import { clearAllStorage } from 'src/utils/auth';

/**
 * Centralized logout side effects so every entry point (account navigation,
 * delete account, etc.) clears the session consistently.
 *
 * It tears down auth state, resets the cart, wipes user-specific RTK Query
 * cache so a previous user's data can never leak to the next session, and
 * clears persisted storage.
 */
const useLogout = () => {
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(logOut());
        dispatch(cartReset());
        dispatch(apiSlice.util.resetApiState());
        clearAllStorage();
    }, [dispatch]);
};

export default useLogout;
